export const intersects = (a: HTMLDivElement, b: HTMLDivElement) => {
  const rectA = a.getBoundingClientRect();
  const rectB = b.getBoundingClientRect();

  const coordsA = {
    x0: rectA.left,
    x1: rectA.right,
    y0: rectA.top,
    y1: rectA.bottom,
  };

  const coordsB = {
    x0: rectB.left,
    x1: rectB.right,
    y0: rectB.top,
    y1: rectB.bottom,
  };

  return (coordsA.x0 <= coordsB.x0 && coordsA.x1 >= coordsB.x0 && coordsA.y1 >= coordsB.y0 && coordsA.y0 <= coordsB.y1);
};